var swiper = new Swiper(".mySwiper", {
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});
// ===== video play paus ebtn ======
$(document).ready(function(){
  $('[data-video-btn]').click(function(){
    $(this).toggleClass("video-play-pause-btn-trigger");
    var video = $(this).parent().find('video').get(0); // Get the video element
    if (video.paused) {
      video.play(); // If paused, play the video
    } else {
      video.pause(); // If playing, pause the video
    }
  });
});
// ======= multimimages slider ========
var sliders = document.querySelectorAll('[data-multi-img-slider]');
if (sliders) {
  sliders.forEach((element, index) => {
    let sliderID = element.getAttribute('data-multi-img-slider');
    var swiper = new Swiper(`${sliderID}`, {
      pagination: {
        el: `${sliderID} .swiper-pagination`,
        clickable: true,
      },
    });
    window[`swiper${index + 1}`] = swiper;
  });
}